<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p>First published in the United States of America in 2019 by Chronicle Books LLC.</p>
<p>Originally published in Japan in 2015 by DOSHINSHA Publishing Co., Ltd., under the title <em>Kiotsukete 2</em>.<br/>English translation rights arranged with DOSHINSHA Publishing Co., Ltd. through Japan Foreign-Rights Centre.</p>
<p>Copyright © 2015 by Taro Gomi.<br/>Translation © 2019 by Chronicle Books LLC.<br/>All rights reserved.</p>
<p>ISBN 978-1-4521-7450-1 (board book)<br/>ISBN 978-1-4521-7742-7 (epub2)<br/>ISBN 978-1-4521-7744-1 (epub3)<br/>ISBN 978-1-4521-7743-4 (kindle)</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>Cover design by Alice Seiler.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02copyright.vue?7db32808